import { mount } from '../dom-lifecycle';
import { setRecaptchaResponse } from './recaptcha';

// Obsługa captchy dla formularzy wysyłanych klasycznym POST-em (nie ajaxem),
// np. logowanie. Token v3 jest pobierany asynchronicznie, więc submit
// wstrzymujemy do czasu wypełnienia pola, a potem wysyłamy formularz natywnie.
mount('.recaptcha-form', form => {
	let tokenReady = false;

	$(form).on('submit', async function (event) {
		if (tokenReady) {
			return;
		}

		event.preventDefault();
		await setRecaptchaResponse(form);
		tokenReady = true;
		form.submit();
	});
});
